import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';
import gsap from 'gsap';
import '../styles/app.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

import videoFeature from './components/videoFeature';
import videoShorts from './components/videoShorts';
import singleVideoHero from './components/singleVideoHero';
import articlesFeatureEnhance from './components/articlesFeatureEnhance';

window.$ = window.jQuery = $;

$(document).ready(function () {
  $(document).foundation();

  function closeMobileMenu() {
    $('.hamburger').removeClass('is-active');
    $('body').removeClass('locked');
    $('.top-bar').removeClass('open');
    $('#mobile-menu').hide();
  }

  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('body').toggleClass('locked');
    $('.top-bar').toggleClass('open');
  });

  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        once: true,
        offset: 80,
        duration: 700,
        easing: 'ease-out-sine',
      });
    }
  }

  // initialize AOS
  initAOS();

  // initialize your components
  videoFeature();
  videoShorts();
  singleVideoHero();
  articlesFeatureEnhance();

  // Smooth scroll
  $('a[href*="#"]').on('click', function (e) {
    const href = $(this).attr('href');

    if (!href || href === '#') return;

    const url = new URL(href, window.location.origin);
    const targetID = url.hash;

    if (!targetID) return;

    const isSamePage =
      url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '') &&
      url.hostname === window.location.hostname;

    if (!isSamePage) return;

    const $target = $(targetID);

    if ($target.length) {
      e.preventDefault();

      closeMobileMenu();

      const headerHeight =
        $('.title-bar:visible').outerHeight() ||
        $('.top-bar:visible').outerHeight() ||
        0;

      $('html, body').stop(true).animate(
        {
          scrollTop: $target.offset().top - headerHeight,
        },
        600,
        function () {
          $('body').removeClass('locked');
        }
      );
    }
  });

  // refresh after everything is mounted
  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refreshHard();
    }
  }, 300);

  function initStickyLogoAnimation() { 
    const svg = document.querySelector('.nav-wrap svg');
    if (!svg) return;

    const rect = svg.querySelector('#logo-reveal rect');
    if (!rect) return;

    const FULL_WIDTH = 1218.65;
    const COLLAPSED_WIDTH = 0;

    let scrollTimer = null;
    let currentState = 'full';

    const showFullLogo = () => {
      if (currentState === 'full') return;

      gsap.to(rect, {
        attr: { width: FULL_WIDTH },
        duration: 1.2,
        ease: 'power3.out',
        overwrite: true,
      });

      currentState = 'full';
    };

    const showCollapsedLogo = () => {
      if (currentState === 'collapsed') return;

      gsap.to(rect, {
        attr: { width: COLLAPSED_WIDTH },
        duration: 1,
        ease: 'power3.out',
        overwrite: true,
      });

      currentState = 'collapsed';
    };

    gsap.set(rect, {
      attr: { width: FULL_WIDTH },
    });

    $(window).on('scroll', function () {
      const scrollTop = window.scrollY || window.pageYOffset;

      if (scrollTop > 0) {
        showCollapsedLogo();
      } else {
        showFullLogo();
      }

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        showFullLogo();
      }, 300);
    });
  }

  initStickyLogoAnimation();

});
